import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'react-bootstrap'

import style from './style.css'

export default function IssueTypeDropdown (props) {
  return (
    <Dropdown id="dropdown-issue-type">
      <Dropdown.Toggle id="dropdown-toggle" className={style.dropdown}>
        <p>
          {props.issueType || 'Issue type'}
        </p>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {issuesTypes.map((issue, i) => {
          return (
            <Dropdown.Item
              className={style.dropdownItem}
              eventKey={i}
              key={`menu-item-${i}`}
              onClick={() => props.onSelect(issue)}
            >
              {issue}
            </Dropdown.Item>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

const issuesTypes = [
  'Technical issue',
  'Correct answer wrong or missing ',
  'Content error in question',
  'Errors in hint or feedback',
  'Formatting errors or typos',
  'Duplicate answer choices',
  'Confusing/ambiguous wording',
  'eBook is not loading/linking'
]

IssueTypeDropdown.propTypes = {
  onSelect: PropTypes.func.isRequired,
  issueType: PropTypes.string
}
